(() => {
  const AB = 16106069492047, AA = 16105607037263;
  const message = 'Płyty A/B zamówisz jako próbkę 1 szt. albo minimum 10 szt. jednego formatu. Płyty A/A wymagają indywidualnej wyceny.';
  const invalid = cart => {
    const totals = new Map();
    for (const item of cart.items) {
      if (item.product_id === AA) return true;
      if (item.product_id === AB) totals.set(item.variant_id, (totals.get(item.variant_id) || 0) + item.quantity);
    }
    return [...totals.values()].some(q => q > 1 && q < 10);
  };
  let busy = false;
  async function checkout(event) {
    const el = event.target;
    const trigger = event.type === 'submit' ? event.submitter : el.closest?.('[name="checkout"],a[href="/checkout"]');
    if (!trigger || trigger.dataset.oakRestricted !== 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    const form = trigger.form;
    if (form && !form.reportValidity()) return;
    busy = true;
    try {
      const response = await fetch('/cart.js', {cache:'no-store'});
      if (!response.ok) throw new Error('cart');
      if (invalid(await response.json())) { alert(message); return; }
      // Preserve cart attributes such as the existing wood acceptance checkbox.
      if (form) {
        const data = new FormData(form);
        const attributes = {};
        for (const [key,value] of data) if (key.startsWith('attributes[')) attributes[key.slice(11,-1)] = value;
        if (Object.keys(attributes).length) {
          const saved = await fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});
          if (!saved.ok) throw new Error('attributes');
        }
      }
      location.href = '/checkout';
    } catch (_) { alert('Nie udało się sprawdzić koszyka. Spróbuj ponownie.'); }
    finally { busy = false; }
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  function sortOptions() {
    document.querySelectorAll('select[data-oak-sort="16106069492047"]').forEach(select => {
      const options = [...select.options];
      const sorted = [...options].sort((a,b) => parseInt(a.value, 10)-parseInt(b.value, 10));
      if (options.every((option, index) => option === sorted[index])) return;
      const selected = select.value;
      sorted.forEach(option => select.append(option));
      select.value = selected;
    });
  }
  sortOptions();
  new MutationObserver(sortOptions).observe(document.body,{subtree:true,childList:true});
})();
